import React, { useRef, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "../../../_actions";
import { User, BookOpen, FileText, Lock, LogOut, Home } from "lucide-react";
import "./ProfileOptions.scss";

function ProfileOptions(props) {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.users);
  const wrapperRef = useRef(null);
  const [isVisible, setIsVisible] = useState(true);
  const options = {
    key: 4,
    label: "Profile",
    submenu: [
      {
        key: 21,
        label: props.label,
        link: props.link,
        icon: "",
        cb: props.handleSelectOption,
      },

      {
        key: 22,
        label: "Profile",
        link: "dashboard/profile",
        icon: "",
        cb: props.handleSelectOption,
      },
      {
        key: 23,
        label: "My Courses",
        link: user.role === 1 ? "dashboard/course/list" : "dashboard/course/list",
        icon: "",
        cb: props.handleSelectOption,
      },

      ...(user.role === 2
        ? [
          {
            key: 26,
            label: "My Exam",
            link: "dashboard/student/quizexam?fullscreen=true",
            icon: "",
            cb: props.handleSelectOption,
          },
        ]
        : []),

      {
        key: 24,
        label: "Security",
        link: "dashboard/profile",
        icon: "",
        cb: props.handleSelectOption,
      },
      {
        key: 25,
        label: "Logout",
        link: "",
        icon: "",
        cb: () => dispatch(userActions.logout()),
      },
    ],
    icon: "",
  };



  return (
    <>
      {isVisible && (
        <div className="profile-options-glassy-menu" ref={wrapperRef}>
          <div className="glassy-arrow"></div>
          <div className="glassy-header">
            <span className="glassy-user-name">{user?.firstName} {user?.lastName}</span>
            <span className="glassy-user-role">
              {user?.role === 1 ? "Administrator" : user?.role === 4 ? "Instructor" : "Student"}
            </span>
          </div>
          <div className="glassy-divider"></div>
          <ul className="glassy-list">
            {options.submenu.map((subM) => {
              const linkParts = (subM.link || "").split('?');
              const path = linkParts[0];
              const searchParams = linkParts[1] ? "?" + linkParts[1] : "";
              
              let IconComponent = User;
              const labelLower = (subM.label || "").toLowerCase();
              if (labelLower.includes("home")) IconComponent = Home;
              else if (labelLower.includes("course")) IconComponent = BookOpen;
              else if (labelLower.includes("exam")) IconComponent = FileText;
              else if (labelLower.includes("security")) IconComponent = Lock;
              else if (labelLower.includes("logout")) IconComponent = LogOut;

              return (
                <Link
                  to={{ pathname: "/" + path, search: searchParams, state: subM.label }}
                  key={subM.key}
                  className="glassy-link"
                >
                  <li onClick={subM.cb ? subM.cb : null} className={`glassy-item ${labelLower.includes("logout") ? "logout-item" : ""}`}>
                    <IconComponent size={16} className="glassy-item-icon" />
                    <span className="glassy-item-label">{subM.label}</span>
                  </li>
                </Link>
              );
            })}
          </ul>
        </div>
      )}
    </>
  );
}

ProfileOptions.propTypes = {
  label: PropTypes.string,
  link: PropTypes.string,
  showOptions: PropTypes.bool,
};

ProfileOptions.defaultProps = {
  label: "yslearn Home",
  link: "",
  showOptions: false,
};

export default ProfileOptions;
